import script from "./MailIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./MailIcon.vue?vue&type=script&setup=true&lang=js"

import "./MailIcon.vue?vue&type=style&index=0&id=520dce87&scoped=true&lang=css"

import exportComponent from "C:\\Source\\Tms\\TmsUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-520dce87"]])

export default __exports__